export const DEFAULT_CONFIGURATIONS = {
  maxOfTasks: 100,
  maxOfFiends: 2,
  maxOfImages: 2,
};
